import { useEffect, useState, useRef } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import Container from "@/components/Container";
import { ErrorMessage } from "@/components/UI";
import { Button } from "@/components/UI/Buttons/Button";
import { Spinner } from "@/components/UI/Spinner";
import { useAuth } from "@/data/context/authContext";
import ROUTES from "@/data/Routes";
import { ROLES } from "@/data/interfaces/RolesEnum";

const GoogleCallback = () => {
  const navigate = useNavigate();
  const { user, productToRegisterFor, authenticateWithGoogle } = useAuth();
  const [searchParams] = useSearchParams();
  const hasHandledCallback = useRef(false);

  const code = searchParams.get("code");
  const error = searchParams.get("error");

  const [errorMsg, setErrorMsg] = useState<string>();
  const [isLoading, setIsLoading] = useState(false);

  const handleCallback = async () => {
    if (hasHandledCallback.current) return;
    hasHandledCallback.current = true;

    if (error || !code) {
      setErrorMsg("Nepavyko prisijungti su Google.");
      setIsLoading(false);
      return;
    }

    try {
      setIsLoading(true);
      await authenticateWithGoogle(code);
      setIsLoading(false);
      navigate(ROUTES.HOME);
    } catch (err: any) {
      console.error(err);
      setErrorMsg("Nepavyko prisijungti su Google.");
      setIsLoading(false);
    }
  };

  useEffect(() => {
    // User not loaded
    if (user === undefined) return;

    if (user) {
      if (
        !user.email_verified_at ||
        (user.role === ROLES.USER && !user.type_form_submitted) ||
        productToRegisterFor
      ) {
        navigate(ROUTES.REGISTER);
      } else {
        navigate(user.isAdmin ? ROUTES.DASHBOARD : ROUTES.ACCOUNT);
      }
      return;
    }

    handleCallback();
  }, [user, productToRegisterFor]);

  const handleGoBack = () => {
    navigate(ROUTES.HOME);
  };

  return (
    <Container>
      <div className="flex min-h-screen items-center justify-center px-4">
        <div className="flex w-full max-w-md flex-col items-center gap-6 text-center">
          {isLoading && !errorMsg && (
            <>
              <Spinner className="text-primary size-10" />
              <div>
                <h1 className="mb-2 text-3xl font-semibold">
                  Prisijungiama su Google
                </h1>
                <p className="text-gray-600 dark:text-gray-400">
                  Prašome palaukti, kol patvirtinsime jūsų paskyrą.
                </p>
              </div>
            </>
          )}

          {errorMsg && (
            <>
              <ErrorMessage error={errorMsg} />
              <Button size="sm" onClick={handleGoBack}>
                Grįžti į prisijungimą
              </Button>
            </>
          )}
        </div>
      </div>
    </Container>
  );
};

export default GoogleCallback;
